"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSelectorKey = void 0;
/**
 * Helper function to build the selector key for a given node
 * so we can easily check if it has been seen before or not (internal only)
 */
const buildSelectorKey = ({ ruleId, selector, url }) => {
    return `__${ruleId}_${url}__${JSON.stringify(selector)}`;
};
exports.buildSelectorKey = buildSelectorKey;
//# sourceMappingURL=buildSelectorKey.js.map